module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"by":"by","lastUpdate":"updt","never":"never","mainNodeStatus":"Main node status","on":"on","shortLastUpdate":"Last update","subjectList":"Subject list"},"fr":{"by":"par","lastUpdate":"Dernière mise à jour","never":"jamais","mainNodeStatus":"Statut du noeud principal","on":"le","shortLastUpdate":"maj","subjectList":"Liste des sujets"}}')
  delete Component.options._Ctor
}
